import { render, staticRenderFns } from "./truck-load-line-item-partial.html?vue&type=template&id=6fac55ae&scoped=true&"
import script from "./truck-load-line-item-partial.ts?vue&type=script&lang=js&"
export * from "./truck-load-line-item-partial.ts?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fac55ae",
  null
  
)

export default component.exports